module.exports = __webpack_public_path__ + "932c68bbafefe99cd885145c0cb67c33.svg";